var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "desc-wrap"
  }, [_c('div', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.txt))])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };